// Basically if the tag is "Offer ends in X days" it should be critical variant, otherwise positive variant
export default function getUrgencyTagVariant(urgencyTag: string) {
  if (urgencyTag.toLocaleLowerCase().includes('ends in')) {
    return 'critical2'
  }
  return 'positive'
}
